import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading_users: false,
    loading_video: false,
    loading_tracks: false,
    loading_budget_spent:false,
    loadging_budget_allocated:false,
    date: {},
    new_users: [],
    video: [],
    tracks: [],
    campaigns: [],
    budget_allocated:[],
    budget_spent:[],
    filterVideo: 'all',
    filterUser: 'default',
    LineChartSett: {
      width: 'auto',
      height: 341,
      is3D: true,
      colors: ['#2e2749', '#e80021'],
      curveType: 'none',
      isStacked: 'relative',
      fontSize: 11,
      fontName: 'Nunito Regular',
      vAxis: {
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 11
        },
        color: '#000',
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 12
        },
        color: '#000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#000',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '7%',
        top: '5%',
        width: '100%',
        height: '75%'
      }
    },
    PieChartSett: {
      width: 'auto',
      height: 330,
      is3D: false,
      pieSliceText: 'value',
      fontName: 'Nunito Bold',
      pieStartAngle: 180,
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: 'none',
      pieHole: 0.5,
      chartArea: {
        width: '90%',
        height: '90%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 14
        },
        showColorCode: true
      },
      slices: {
        0: { color: '#F2F1F1',textStyle: {color: 'black'}},
        1: { color: '#B6B0BF' },
        2: { color: '#FFA500' }
      }
    },
    PieChartTracks: {
      width: 'auto',
      height: 330,
      is3D: false,
      pieSliceText: 'value',
      fontName: 'Nunito Bold',
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: 'none',
      pieHole: 0.5,
      chartArea: {
        width: '100%',
        height: '90%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 14
        },
        showColorCode: true
      },
      slices: {
        0: { color: '#D40C41' },
        1: { color: '#F2F1F1',textStyle: {color: 'black'}}
      }
    },
    ColumnChart: {
      width: 'auto',
      height: 330,
      colors: ['#B6B0BF'],
      fontName: 'Nunito Regular',
      legend: { position: 'bottom', maxLines: 5 },
      bar: { groupWidth: '75%' },
      chartArea: {
        left: '0',
        top: '4%',
        width: '100%',
        height: '70%',
      },
      annotations: {
        alwaysOutside: true
      }
    },
    userTiersAndPlatformsChart: {
      width: 'auto',
      height: 330,
      is3D: false,
      isStacked: true,
      colors: ['#73d40c', '#b9d40c','#d4a50c', '#d44f0c', '#D40C41'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 5
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      focusTarget: 'category',
      chartArea: {
        width: '70%'
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    },
    GeoChartSett: {
      width: 'auto',
      height: 'auto',
      is3D: true,
      fontName: 'Nunito Regular',
      legend: 'none',
      chartArea: {
        right: '0',
        top: '0',
        width: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 15
        },
        showColorCode: true
      },
      colors: [
        '#F906E1',
        '#AD0AFC',
        '#0606F9',
        '#07F9F9',
        '#09FB19',
        '#FEE507',
        '#FF7F00',
        '#FC0000'
      ]
    },
    BarChartSett: {
      width: 'auto',
      height: 330,
      is3D: false,
      colors: ['#2e2749', '#554c78', '#a39dbd'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 5
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    },
    CampaignChartSett: {
      width: 'auto',
      height: 330,
      is3D: false,
      colors: ['#D40C41', '#B6B0BF'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 5
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      },
      annotations: {
        textStyle: {
          color: 'black',
          fontSize: 11
        },
        alwaysOutside: true
      }
    },
    VideoChartSet: {
      width: 'auto',
      height: 330,
      is3D: false,
      colors: ['#73d40c', '#b9d40c','#d4a50c', '#d44f0c', '#D40C41'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 5
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    },
    TrackChartSet: {
      width: 'auto',
      height: 330,
      is3D: false,
      colors: ['#D40C41', '#F2F1F1'],
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16
        },
        showColorCode: true
      },
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 20,
          colors: ['#2c67a5']
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 5
        },
        textStyle: {
          fontSize: 15
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        minorGridlines: {
          colors: ['#2c67a5', '#e80021', '#1b9e77', '#2c67a5']
        },
        textStyle: {
          fontSize: 15
        }
      },
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        width: '70%'
      },
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    }
  },

  mutations: {
    setLoadingNewUsers(state, payload) {
      state.loading_users = payload
    },
    setLoadingCampaigns(state, payload) {
      state.loading_campaigns = payload
    },
    setNewUsersData(state, payload) {
      state.new_users = payload
    },
    setCampaigns(state, payload) {
      state.campaigns = payload
    },
    setLoadingVideo(state, payload) {
      state.loading_video = payload
    },
    setLoadingTracks(state, payload) {
      state.loading_tracks = payload
    },
    setVideoData(state, payload) {
      state.video = payload
    },
    setLoadingBudgetSpent(state, payload){
      state.loading_budget_spent = payload
    },
    setLoadingBudgetAllocated(state, payload){
      state.loading_budget_allocated = payload
    },
    setBudgetAllocated(state, payload) {
      state.budget_allocated = payload
    },
    setBudgetSpent(state, payload) {
      state.budget_spent = payload
    },
    setTracksData(state, payload) {
      state.tracks = payload
    },
    setDate(state, payload) {
      state.date = payload
    },
    setFilterVideo(state, payload) {
      state.filterVideo = payload
    },
    setFilterUser(state, payload) {
      state.filterUser = payload
    }
  },

  actions: {
    readNewUsers({ commit, state }, data) {
      commit('setLoadingNewUsers', true)
      axios.admin
        .get(`statistics/new-users/${state.date.date_start}/${state.date.date_end}?type=${state.filterUser}`)
        .then(r => {
          //console.log(r.data.data)
          commit('setNewUsersData', r.data.data)
          commit('setLoadingNewUsers', false)
        })
        .catch(() => {
          commit('setLoadingNewUsers', false)
        })
    },
    readCampaigns({ commit }, data) {
      commit('setLoadingCampaigns', true)
      axios.admin
        .get(`statistics/campaigns/${data.date_start}/${data.date_end}`)
        .then(r => {
          commit('setCampaigns', r.data.data)
          commit('setLoadingCampaigns', false)
        })
        .catch(() => {
          commit('setLoadingCampaigns', false)
        })
    },
    readVideoData({ commit, state }, data) {
      commit('setLoadingVideo', true)
      axios.admin
        .get(`statistics/videos/${state.date.date_start}/${state.date.date_end}?status=${state.filterVideo}`)
        .then(r => {
          commit('setVideoData', r.data.data)
          commit('setLoadingVideo', false)
        })
        .catch(() => {
          commit('setLoadingVideo', false)
        })
    },
    readTracksData({ commit }, data) {
      commit("setLoadingTracks", true);
      axios.admin
        .get(`statistics/tracks/${data.date_start}/${data.date_end}`)
        .then(r => {
          commit(
            "setTracksData", r.data.data
          );
          commit("setLoadingTracks", false);
        })
        .catch(() => {
          commit("setLoadingTracks", false);
        });
    },
    readBudgetAllocated({ commit }, data) {
      commit('setLoadingBudgetAllocated', true)
      axios.admin
        .get(`statistics/budget/${data.date_start}/${data.date_end}`)
        .then(r => {
          r.data.data.map(s => {
            s.bonus = s.bonus/10
            s.standard = s.standard/10
          })
          commit('setBudgetAllocated', r.data.data)
          commit('setLoadingBudgetAllocated', false)
        })
        .catch(() => {
          commit('setLoadingBudgetAllocated', false)
        })
    },
    readBudgetSpent({ commit }, data) {
      commit('setLoadingBudgetSpent', true)
      axios.admin
        .get(`statistics/budget-spent/${data.date_start}/${data.date_end}`)
        .then(r => {
          r.data.data.map(s => {
            s.balance = s.balance/10
          })
          commit('setBudgetSpent', r.data.data)
          commit('setLoadingBudgetSpent', false)
        })
        .catch(() => {
          commit('setLoadingBudgetSpent', false)
        })
    },
  },

  getters: {
    track_chart: state => {
      let result = []
      if (state.new_users.length > 0) {
        result = [['Total', 'Live', 'Ended']]
        state.new_users.map(s => {
          result.push([
            s.title,
            Number(50),
            Number(20)
          ])
        })
      }
      return result
    },
    video_chart: state => {
      let result = []
      if (state.video.length > 0) {
        result = [[
            'Videos', 'Nano',{ role: "annotation" }, 'Micro',{ role: "annotation" },'Mid',{ role: "annotation" },
            'Macro',{ role: "annotation" }, 'Elite',{ role: "annotation" }
        ]]
        state.video.map(s => {
          result.push([
            s.period,
            Number(s.nano), Number(s.nano),
            Number(s.micro), Number(s.micro),
            Number(s.mid), Number(s.mid),
            Number(s.macro), Number(s.macro),
            Number(s.elite), Number(s.elite)
          ])
        })
      }
      return result
    },
    tracks_chart: state => {
      let result = []
      if (state.tracks.length > 0) {
        result = [['Total', 'Budget', { role: "annotation" },'Free', { role: "annotation" }]]
        state.tracks.map(s => {
          result.push([
            s.period,
            Number(s.active),
            Number(s.active),
            Number(s.inactive),
            Number(s.inactive)
          ])
        })
      }
      return result
    },
    campaign_chart: state => {
      let result = []
      if (state.campaigns.length > 0) {
        result = [['Total', 'Live', { role: "annotation" },'Ended',{ role: "annotation" }]]
        state.campaigns.map(s => {
          result.push([
            s.week,
            Number(s.live),
            Number(s.live),
            Number(s.ended),
            Number(s.ended)
          ])
        })
      }
      return result
    },
    budget_allocated_chart: state => {
      let result = []
      if (state.budget_allocated.length > 0) {
        result = [[
            'Element', 'topUp', { role: "annotation" },
            'Bonus', { role: "annotation" }
        ]]
        state.budget_allocated.map(s => {
          result.push([
            s.period,
            Number(s.standard), Number(s.standard),
            Number(s.bonus), Number(s.bonus)
          ])
        })
      }
      return result
    },
    budget_spent_chart: state => {
      let result = []
      if (state.budget_spent.length > 0) {
        result = [['Element', 'Budget Spent', { role: "annotation" }]]
        state.budget_spent.map(s => {
          result.push([
            s.period,
            Number( s.balance),
            Number( s.balance)
          ])
        })
      }
      return result
    },
    users_chart: state => {
      let result = [];
      if (state.new_users.length > 0) {
        result = [["Element", "New Sign-ups", { role: "style" }, { role: "annotation" }]];
        state.new_users.forEach(s => {
          result.push(["Verified", Number(s.verified), "#73d40c", Number(s.verified)]),
          result.push(["Unverified", Number(s.unverified), "#D40C41", Number(s.unverified)]),
          result.push(["Artist", Number(s.artists), "#d4a50c", Number(s.artists)]),
          result.push(["Label", Number(s.labels), "#b9d40c", Number(s.labels)])
        });
      }
      return result;
    },
    tiersChart: state => {
      let result = [];
      if (state.new_users.length > 0 && state.filterUser === 'tier') {
        result = [['Type', 'Nano', 'Micro','Mid', 'Macro', 'Elite']]

        state.new_users.sort((a, b) => b.type.localeCompare(a.type))
            .forEach(s => {
              result.push([
                s.type.charAt(0).toUpperCase() + s.type.slice(1),
                Number(s.nano), Number(s.micro), Number(s.mid),
                Number(s.macro), Number(s.elite),
              ])
        })
      }
      return result;
    },
    platformsChart: state => {
      let result = []

      if (state.new_users.length > 0 && state.filterUser === 'platform') {
        result = [['Platform', 'Approved', 'Rejected', 'Pending']]

        state.new_users.forEach(s => {
              result.push([
                s.type.charAt(0).toUpperCase() + s.type.slice(1),
                Number(s.approved), Number(s.rejected), Number(s.pending)
              ])
            })
      }
      console.log(result)
      return result;
    },
    getFilterVideo(state) {
      return state.filterVideo
    },
    getFilterUser(state) {
      return state.filterUser
    }
  }
}
